import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, Row, Col } from 'reactstrap';
import { getCatalogItems, addCheckList, getCheckList } from 'store/actions';
import CreateCheckList from './CreateCheckList';
import CheckListTable from './CheckListTable';
import Breadcrumb from 'components/Common/Breadcrumb2';

const CheckList = ({id}) => {
    const [selectedCatalogue, setSelectedCatalogue] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const dispatch = useDispatch();

    const catalogues = useSelector((state) => state.Catalog.catalogItems);
    const checklistItems = useSelector((state) => state.Checklist.checklist);
    const loading = useSelector((state) => state.Checklist.loading);
    const error = useSelector((state) => state.Checklist.error);

    const permissions = JSON.parse(localStorage?.getItem('permissions'));

    // Fetch catalogues and checklist items when the component mounts
    useEffect(() => {
        if(loading)return;
        dispatch(getCatalogItems());
        dispatch(getCheckList(id));
    }, [dispatch]);

    const handleSelectCatalogue = (selectedOption) => {
        setSelectedCatalogue(selectedOption);
    };

    const handleAddChecklistItem = (data) => {
        dispatch(addCheckList(data));
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    // Filter checklist items based on the selected catalogue
    const filteredChecklistItems = selectedCatalogue
        ? checklistItems?.Data.filter(item => item.catalogueId === selectedCatalogue.value)
        : checklistItems?.Data;

    return (
        <>
            <CreateCheckList
                visible={isModalOpen}
                onSubmit={handleAddChecklistItem}
                handleClose={handleCloseModal}
                id={id}
            />
            <div className="container-fluid">
                <div className="d-flex justify-content-between align-items-center ms-3">
                    <Breadcrumb title="Checklists" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Checklists", link: '#' }]} />
                    {permissions?.map(item=>item?.permissionName)?.includes("Add Checklists") && <Button
                        className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
                        onClick={() => setIsModalOpen(true)}
                    >
                        <i className="ti-plus"></i>Add New
                    </Button>}
                </div>
                <Row className="" style={{marginLeft:"1px"}}>
                    <Col lg={4}>
                        <Row className="mb-3">
                            {/* <Col xs={12}>
                                <Select
                                    value={selectedCatalogue}
                                    onChange={handleSelectCatalogue}
                                    options={catalogues?.Data?.map((cat) => ({
                                        value: cat.catalogueId,
                                        label: cat.itemName,
                                    }))}
                                    isClearable={true}
                                    classNamePrefix="select2-selection"
                                    placeholder="Select Catalogue"
                                />
                            </Col> */}
                        </Row>
                    </Col>
                    <Col className="mb-3" lg={8}>

                    </Col>
                </Row>
                <CheckListTable
                    List={filteredChecklistItems}
                    loading={loading}
                    error={error}
                    id={id}
                />
            </div>
        </>
    );
};

export default CheckList;
